/* USERS */
export const GET_CONTACT_LIST = "GET_CONTACT_LIST"
export const GET_CONTACT_LIST_SUCCESS = "GET_CONTACT_LIST_SUCCESS"
export const GET_CONTACT_LIST_FAIL = "GET_CONTACT_LIST_FAIL"
export const GET_CONTACT_LIST_DETAIL = "GET_CONTACT_LIST_DETAIL"
export const GET_CONTACT_LIST_DETAIL_SUCCESS = "GET_CONTACT_LIST_DETAIL_SUCCESS"
export const GET_CONTACT_LIST_DETAIL_FAIL = "GET_CONTACT_LIST_DETAIL_FAIL"

/* USERS PROFILE */
export const GET_USER_PROFILE = "GET_USER_PROFILE"
export const GET_USER_PROFILE_SUCCESS = "GET_USER_PROFILE_SUCCESS"
export const GET_USER_PROFILE_FAIL = "GET_USER_PROFILE_FAIL"

/**
 * add user
 */
export const ADD_NEW_USER = "ADD_NEW_USER"
export const ADD_USER_SUCCESS = "ADD_USER_SUCCESS"
export const ADD_USER_FAIL = "ADD_USER_FAIL"

/**
 * Edit user
 */
export const UPDATE_USER = "UPDATE_USER"
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS"
export const UPDATE_USER_FAIL = "UPDATE_USER_FAIL"

/**
 * Delete user
 */
export const DELETE_USER = "DELETE_USER"
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS"
export const DELETE_USER_FAIL = "DELETE_USER_FAIL"
